export const GET_HALL_NUMBERS = "GET_HALL_NUMBERS";
export const GET_HALL_NUMBER = "GET_HALL_NUMBER";
export const ADD_HALL_NUMBER = "ADD_HALL_NUMBER";
export const DELETE_HALL_NUMBER = "DELETE_HALL_NUMBER";
export const UPDATE_HALL_NUMBER = "UPDATE_HALL_NUMBER";
